// extracted by mini-css-extract-plugin
export var card = "PresentationCard-module--card--vrMaZ";
export var container = "PresentationCard-module--container--opJg3";
export var content = "PresentationCard-module--content--v1cZ3";
export var image = "PresentationCard-module--image--30vTA";
export var imageContainer = "PresentationCard-module--imageContainer--Ujj85";
export var underlinedH3 = "PresentationCard-module--underlinedH3--QJYJf";